// @mui
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
// hooks
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// routes
// locales
import { useLocales } from 'src/locales';
// components
import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify';
import { useRouter } from 'src/routes/hooks';
import { useSnackbar } from 'src/components/snackbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  // const { user } = useMockedUser();
  const router = useRouter();
  const { logout } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const confirm = useBoolean();

  const handleLogout = async () => {
    try {
      setLoading(true);
      await logout();
      sessionStorage.removeItem('view');
      sessionStorage.removeItem('courseSectionsView');
      router.replace('/');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const { t } = useLocales();

  return (
    <>
      <Stack
        sx={{
          px: 2,
          py: 2,
          textAlign: 'center',
        }}
      >
        <Stack alignItems="center">
          {/* <Box sx={{ position: 'relative' }}>
            <Avatar src={user?.photoURL} alt={user?.displayName} sx={{ width: 48, height: 48 }} />
            <Label
              color="success"
              variant="filled"
              sx={{
                top: -6,
                px: 0.5,
                left: 40,
                height: 20,
                position: 'absolute',
                borderBottomLeftRadius: 2,
              }}
            >
              Free
            </Label>
          </Box> */}

          {/* <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.displayName}
            </Typography>

            <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
              {user?.email}
            </Typography>
          </Stack> */}

          <Button
            onClick={confirm.onTrue}
            sx={{
              background: '#43A75633',
              color: '#000000',
              '&:hover': {
                background: '#43A756', // Change background color on hover
                color: '#ffffff', // Change text color on hover
              },
            }}
            startIcon={<Iconify icon="majesticons:logout" />}
            fullWidth
            // sx={{ w: '100%' }}
            variant="contained"
          >
            Log Out
            {/* {t('upgrade_to_pro')} */}
          </Button>
        </Stack>
      </Stack>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Logout"
        content="Are you sure want to Logout?"
        action={
          <LoadingButton
            loading={loading}
            variant="contained"
            color="error"
            onClick={handleLogout}
          >
            Logout
          </LoadingButton>
        }
      />
    </>
  );
}
